import {
  KIOSK_SETTINGS_URL,
  KIOSK_ME_URL,
  KIOSK_LOGIN_URL,
  KIOSK_LOGOUT_URL,
  KIOSK_JOBS_URL,
  KIOSK_MOMENTS_URL,
  KIOSK_SELECTION_URL,
  KIOSK_GUESTS_URL,
  CUSTOMER_UPDATE_URL,
  ROOM_MOMENTS_URL,
  FAMILIES_URL,
  VISITS_URL,
  VISIT_URL,
  SEARCH_VISITS_URL,
  SEARCH_CUSTOMERS_URL,
  MERGED_STORIES_URL,
  ADD_MERGED_STORY_URL,
  AUTHORIZE_PIN_URL,
  GET_KIOSK_PRINT_SIZES_URL,
  KIOSK_READER_UPDATE_URL,
  SEARCH_MOMENTS_URL,
  GET_KNOCKOUT_ELEMENTS,
  FETCH_KNOCKOUT_IMAGE,
  BACKUP_MOMENT_URL,
  STRIPE_KIOSK_READERS_URL,
  STRIPE_KIOSK_READER_URL,
  VALIDATE_KNOCKOUT_ELEMENTS_URL,
  CHECK_EXISTING_EDITS_URL,
  MOMENT_PRINT_SIZES_URL,
} from 'app/utils/Constants';

import {
  LOGIN_URL,
  REGISTER_STRIPE_TERMINAL_URL
} from 'shared/utils/Constants'

import {
  get,
  post,
  put,
  patch,
  destroy
} from 'shared/services/ApiService';

class KioskService {
  async getSettings(token) {
    return get(KIOSK_SETTINGS_URL(token));
  }

  async me(token) {
    return get(KIOSK_ME_URL(token));
  }

  async login(token, params) {
    return post(KIOSK_LOGIN_URL(token), params);
  }

  async logout() {
    return get(KIOSK_LOGOUT_URL());
  }

  async getJobs(token, since) {
    return get(KIOSK_JOBS_URL(token, since));
  }

  async getMoments(token, jobId, page, perPage, since) {
    return get(KIOSK_MOMENTS_URL(token, jobId, page, perPage, since));
  }

  async getRoomMoments(token, storyId, page, perPage) {
    return get(ROOM_MOMENTS_URL(token, storyId, page, perPage));
  }

  async getSelections(token, storyId) {
    return get(KIOSK_SELECTION_URL(token, storyId));
  }

  async selectMoments(token, storyId, momentIds) {
    const params = {
      moment_ids: momentIds
    }

    return post(KIOSK_SELECTION_URL(token, storyId), params);
  }

  async unselectMoment(token, storyId, momentId) {
    const params = {
      moment_ids: [momentId]
    }

    return patch(KIOSK_SELECTION_URL(token, storyId), params);
    //return destroy(KIOSK_UNSELECT_URL(token, storyId, momentId));
  }

  async updateCustomer(customerId, params) {
    return put(CUSTOMER_UPDATE_URL(customerId), params);
  }

  async getGuests(token, storyId) {
    return get(KIOSK_GUESTS_URL(token, storyId));
  }

  async createFamily(token, storyId) {
    return post(FAMILIES_URL(token), { story_id: storyId });
  }

  async getVisits(token, familyId) {
    return get(VISITS_URL(token, familyId));
  }

  async addVisit(token, familyId, visitId) {
    return post(VISITS_URL(token, familyId), { visit_id: visitId });
  }

  async removeVisit(token, familyId, visitId) {
    return destroy(VISIT_URL(token, familyId, visitId));
  }

  async searchVisits(token, room) {
    return get(SEARCH_VISITS_URL(token, room));
  }

  async fetchMergedStories(token, storyId) {
    return get(MERGED_STORIES_URL(token, storyId));
  }

  async addMergedStory(token, targetStoryId, sourceStoryId) {
    return post(ADD_MERGED_STORY_URL(token), { target_story_id: targetStoryId, source_story_id: sourceStoryId });
  }

  async searchCustomers(token, customerId, search) {
    return get(SEARCH_CUSTOMERS_URL(token, customerId, encodeURIComponent(search)));
  }

  async authorizePin(accountId, pin) {
    return post(AUTHORIZE_PIN_URL(accountId), { pin });
  }

  async getKioskPrintSizes(kioskId) {
    return get(GET_KIOSK_PRINT_SIZES_URL(kioskId));
  }

  async updateKioskReader(token, params) {
    return put(KIOSK_READER_UPDATE_URL(token), params);
  }

  async getPortalMoments(params, moments = []) {
    return post(SEARCH_MOMENTS_URL(), params)
      .then(momentsPage => {
        moments = moments.concat(momentsPage.records);

        // if (momentsPage.records.length === params.per_page) {
        //   params.page = params.page + 1
        //   return this.getPortalMoments(params, moments);
        // }
        return Promise.resolve(moments);
      });
  }

  async getPortalMomentCount(params) {
    return post(SEARCH_MOMENTS_URL(), params)
      .then(momentsPage => {
        return Promise.resolve(momentsPage.total_count);
      });
  }

  async getKnockoutElements(momentId, printSizeString) {
    return get(GET_KNOCKOUT_ELEMENTS(momentId, printSizeString))
      .then(elements => {
        return Promise.resolve(elements);
      });
  }
  async validateKnockoutElements(momentId, printSizeString) {
    return get(VALIDATE_KNOCKOUT_ELEMENTS_URL(momentId, printSizeString))
      .then(elements => {
        return Promise.resolve(elements);
      });
  }


  async getMomentPrintSizes(kioskId, momentId) {
    return await get(MOMENT_PRINT_SIZES_URL(kioskId, momentId));
  }

  async getKnockoutImage(momentId) {
    return get(FETCH_KNOCKOUT_IMAGE(momentId));
  }

  async backupMoment(momentId) {
    return get(BACKUP_MOMENT_URL(momentId));
  }

  async getStripeReaders(token) {
    return get(STRIPE_KIOSK_READERS_URL(token));
  }

  async createStripeReader(token, params) {
    return post(STRIPE_KIOSK_READERS_URL(token), params);
  }

  async updateStripeReader(token, readerId, params) {
    return put(STRIPE_KIOSK_READER_URL(token, readerId), params);
  }

  async deleteStripeReader(token, readerId) {
    return destroy(STRIPE_KIOSK_READER_URL(token, readerId));
  }

  async registerStripeReader(accountId, params) {
    return post(REGISTER_STRIPE_TERMINAL_URL(accountId), params);
  }
}

export default new KioskService();
